function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React from 'react';

import { SonntagIcon } from "../../SonntagIcon";
import withRipple from "../../hocs/withRipple";

import { Btn, BtnContent, BtnText, BtnIcon } from "./styles";
import { ButtonColor } from "./types";

const ButtonWithRippleEffect = withRipple(Btn);

const renderIcon = (icon, iconPath) => {
  if (iconPath) {
    return /*#__PURE__*/React.createElement(SonntagIcon, { iconPath: iconPath, color: "currentColor" });
  }

  if (icon) {
    return icon;
  }

  return null;
};

export const Button = ({
  type = 'button',
  isDisabled = false,
  small = false,
  outlined = false,
  borderColor,
  color = ButtonColor.grey,
  fullWidth,
  icon,
  iconPath,
  children,
  rippleColor,
  ...rest }) =>
{
  return /*#__PURE__*/(
    React.createElement(ButtonWithRippleEffect, _extends({
      role: "button",
      type: type,
      disabled: isDisabled,
      outlined: outlined,
      borderColor: borderColor,
      color: color,
      small: small,
      iconBtn: !!icon || !!iconPath,
      hasChildren: !!children,
      fullWidth: Boolean(children && fullWidth),
      rippleColor: rippleColor },
    rest), /*#__PURE__*/

    React.createElement(BtnContent, null,
    (!!icon || !!iconPath) && /*#__PURE__*/
    React.createElement(BtnIcon, { hasMargin: !!children, small: small },
    renderIcon(icon, iconPath)),


    !!children && /*#__PURE__*/React.createElement(BtnText, null, children))));



};

export { ButtonColor };